import moment from 'moment';
import { ReportType } from '@cambridgeassessment/lib-ee-commons';
import { Report } from '../../types/Series';

const submissionReportOrder = [
  ReportType.SUBMITTED_EXAMINED,
  ReportType.SUBMITTED_MODERATED,
  ReportType.NOT_SUBMITTED_EXAMINED,
  ReportType.NOT_SUBMITTED_MODERATED,
  ReportType.RMA_ERRORS,
];

export const sortSections = (submissions: Report[]): Report[] => {
  return [...submissions].sort((a, b) => {
    const reportAPriority = submissionReportOrder.findIndex((it) => it === (a.reports[0] as ReportType));
    const reportBPriority = submissionReportOrder.findIndex((it) => it === (b.reports[0] as ReportType));
    return moment(b.series.name).diff(moment(a.series.name)) || reportAPriority - reportBPriority;
  });
};
